import smoothscroll from "smoothscroll-polyfill";
import "url-search-params-polyfill";

if (
    typeof NodeList !== "undefined" &&
    NodeList.prototype &&
    !NodeList.prototype.forEach
) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}
require("@babel/polyfill");
require("./vendor/blob-polyfill");
require("./vendor/jquery-ui.min");
require("isomorphic-fetch");
// kick off the polyfill!
smoothscroll.polyfill();
var $ = require("jquery");

$(function () {
    $(".datepicker").datepicker({
        dateFormat: 'dd/mm/yy',
        minDate: "+1D",
        maxDate: "+1Y",
        firstDay: 1,
        closeText: "Sluiten",
        prevText: "Vorig",
        nextText: "Volgende",
        currentText: "Vandaag",
        monthNames: [ "januari", "februari", "maart", "april", "mei", "juni",
            "juli", "augustus", "september", "oktober", "november", "december" ],
        monthNamesShort: [ "jan", "feb", "mrt", "apr", "mei", "jun",
            "jul", "aug", "sep", "okt", "nov", "dec" ],
        dayNames: [ "zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag" ],
        dayNamesShort: [ "zon", "maa", "din", "woe", "don", "vri", "zat" ],
        dayNamesMin: [ "zo", "ma", "di", "wo", "do", "vr", "za" ],
        weekHeader: "Wk",
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: ""});
});

const searchClear = () => {
    $(".SELECT_SEARCH_OVERLAY")
        .addClass("hidden")
        .removeClass("fixed");

    $(".SELECT_SEARCH_LOADING")
        .addClass("hidden")
        .removeClass(["absolute"]);
    $(".SELECT_SEARCH_RESULTS")
        .addClass("hidden")
        .removeClass(["absolute"]);

    $(".SELECT_SEARCH").val("");

    $(".SELECT_SEARCH_EMPTY")
        .addClass("hidden")
        .removeClass(["absolute"]);
};

const searchLoading = () => {
    $(".SELECT_SEARCH_LOADING")
        .addClass(["absolute"])
        .removeClass("hidden");
    $(".SELECT_SEARCH_EMPTY")
        .addClass("hidden")
        .removeClass(["absolute"]);
    $(".SELECT_SEARCH_RESULTS").html("");
    $(".SELECT_SEARCH_OVERLAY")
        .addClass("fixed")
        .removeClass("hidden");
    $(".SELECT_SEARCH_CLOSE")
        .addClass("hidden")
        .removeClass(["absolute"]);
};

const searchResults = () => {
    $(".SELECT_SEARCH_LOADING")
        .addClass("hidden")
        .removeClass(["absolute"]);
    $(".SELECT_SEARCH_RESULTS")
        .addClass(["absolute"])
        .removeClass("hidden");
    $(".SELECT_SEARCH_CLOSE")
        .addClass(["absolute"])
        .removeClass("hidden");
};

const searchEmpty = () => {
    //misschien niet nodig
    $(".SELECT_SEARCH_EMPTY")
        .addClass(["absolute"])
        .removeClass("hidden");
};

const searchElement = (title, link, subtitle) => {
    // <img class="hiddden" src="images/products/${
    //     e.searchable.image
    //     }" alt="${e.searchable.name}">

    return `
<a href="/${link}">
    <div class="flex py-4 border-b border-b-gray-800 hover:bg-gray-200 px-4 cursor-pointer">
        <div>
            <h6 class="font-head font-bold">${title}</h6>
            <span class="text-sm">${subtitle}</span>
        </div>
    </div>
</a>`;
};

$(".SELECT_SEARCH").on(
    "keyup",
    delay(function (e) {
        //$(".search-results").addClass("loading");

        e.preventDefault();
        let value = $(this).val();
        if (value) {
            $.ajax({
                type: "post",
                url: "/search",
                dataType: "json",
                data: {search: value},
                beforeSend: function () {
                    if (value.length > 0) {
                    }
                    searchLoading();
                },
                success: function (data) {
                    const filteredData = Object.values(data).filter(item => {
                        if (item.type !== "products" && item.type !== "product_infos") {
                            return true;
                        }

                        const matchingLandingPage = Object.values(data).find(landingPage =>
                            landingPage.type === "landing_pages" &&
                            landingPage.searchable.product_id === item.searchable.id &&
                            landingPage.searchable.name === item.searchable.name
                        );

                        return !matchingLandingPage;
                    });

                    filteredData.map(e => {
                        if ((e.type === "products") || (e.type === "product_infos")) {
                            $(".SELECT_SEARCH_RESULTS").append(
                                searchElement(
                                    e.searchable.name,
                                    "bestellen/" + e.searchable.slug,
                                    e.searchable.description
                                )
                            );
                        } else if (e.type === "pages") {
                            $(".SELECT_SEARCH_RESULTS").append(
                                searchElement(
                                    e.searchable.name,
                                    "page/" + e.searchable.slug,
                                    "Algemene informatie"
                                )
                            );
                        } else if (e.type === "customer_care_pages") {
                            $(".SELECT_SEARCH_RESULTS").append(
                                searchElement(
                                    e.searchable.title,
                                    "klantenservice/" + e.searchable.slug,
                                    "Klantenservice"
                                )
                            );
                        } else {
                            $(".SELECT_SEARCH_RESULTS").append(
                                searchElement(
                                    e.searchable.name,
                                    e.searchable.slug,
                                    ""
                                )
                            );
                        }
                    });

                    if (data.length < 6) {
                        $(".SELECT_SEARCH_RESULTS").append(
                            searchElement(
                                "Offerte aanvragen",
                                "offerteaanvraag-formulier",
                                "Op zoek naar een niet standaard product? Vraag een offerte aan! Wij helpen je verder"
                            )
                        );
                    }
                    searchResults();
                    //
                },
                error: function (xhr) {
                    if (xhr.status === 419) {
                        location.reload();
                    }
                    // $(".search-results").removeClass("loading");
                    // $(".search-results").hide();
                    throw xhr.responseJSON.errors;
                }
            });
        }
    }, 500)
);

$(".SELECT_SEARCH_OVERLAY").click(function () {
    searchClear();
});

$(".SELECT_SEARCH_CLOSE").click(function () {
    searchClear();
});

$("#toggle-one").on("change", function (e) {
    if (this.checked) {
        $(".SELECT_MENU_MOBILE")
            .removeClass("fa-bars")
            .addClass("fa-times");
    } else {
        $(".SELECT_MENU_MOBILE")
            .removeClass("fa-times")
            .addClass("fa-bars");
    }
});

$.ajaxSetup({
    headers: {
        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content")
    }
});

function delay(callback, ms) {
    var timer = 0;
    return function () {
        var context = this,
            args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            callback.apply(context, args);
        }, ms || 0);
    };
}

document.querySelectorAll(".TOGGLE_ACCORDION").forEach(e => {
    const parent = e;
    const id = e.dataset.id;
    parent.onclick = function (event) {
        toggle(parent, id);
    };
});

if (window.location.hash) {
    const id = window.location.hash.split("#")[1];
    const element = document.querySelector(`[data-id="${id}"]`);

    toggle(element, id);
    element.scrollIntoView();
}

function toggle(parent, id) {
    const selectedElement = parent;
    const head = selectedElement.querySelector("h6");
    const content = selectedElement.querySelector(".content");
    const i = selectedElement.querySelector("i");

    head.classList.toggle("font-bold");

    if (i.classList.contains("fa-plus")) {
        i.classList.remove("fa-plus");
        i.classList.add("fa-minus");
    } else {
        i.classList.add("fa-plus");
        i.classList.remove("fa-minus");
    }
    selectedElement.classList.toggle("flex-wrap");
    content.classList.toggle("hidden");

    const check = selectedElement.querySelector("i");

    if (check.classList.contains("fa-plus")) {
        history.pushState(
            "",
            document.title,
            window.location.pathname + window.location.search
        );
    } else {
        window.location.hash = id;
    }
}

$(".SELECT_ACCOUNT_MENU_MOBILE").change(function () {
    window.location = $(this).val();
});

$("#selectFilesBtn").on("click", function() {
    $("#file").click();
});

// Store selected files
let selectedFiles = [];

$("#file").on("change", function(e) {
    const newFiles = Array.from(e.target.files);

    selectedFiles = [...selectedFiles, ...newFiles];

    updateSelectedFilesList();

    $(this).val('');
});

function formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

function updateSelectedFilesList() {
    const $filesList = $("#selectedFilesList");
    $filesList.empty();

    if (selectedFiles.length === 0) {
        $("#uploadButton").addClass("hidden");
        return;
    } else {
        $("#uploadButton").removeClass("hidden");
    }

    const $headerContainer = $("<div>").addClass("flex justify-between items-center mb-2");

    const $header = $("<div>")
        .addClass("font-bold")
        .text(`Geselecteerde bestanden (${selectedFiles.length}):`);

    const $clearAllBtn = $("<button>")
        .attr("type", "button")
        .addClass("text-sm text-red-500 hover:text-red-700")
        .text("Alles verwijderen")
        .on("click", function() {
            selectedFiles = [];
            updateSelectedFilesList();
        });

    $headerContainer.append($header);
    $headerContainer.append($clearAllBtn);
    $filesList.append($headerContainer);

    const $fileList = $("<div>").addClass("border rounded pl-3 pr-3 pb-2 bg-gray-50");

    selectedFiles.forEach((file, index) => {
        const fileId = `${file.name}-${file.lastModified}`;
        const fileSize = formatFileSize(file.size);

        const $fileItem = $("<div>").addClass("pt-2 pb-2 flex items-center justify-between border-b border-gray-200 last:border-0 last:mb-0 last:pb-0");
        const $fileInfo = $("<div>").addClass("flex-grow");

        $fileInfo.append(
            $("<div>").text(file.name).addClass("font-medium text-gray-800")
        );

        $fileInfo.append(
            $("<div>").text(fileSize).addClass("text-sm text-gray-500")
        );

        $fileItem.append($fileInfo);

        const $deleteBtn = $("<button>")
            .attr("type", "button")
            .attr("data-file-id", fileId)
            .addClass("ml-3 p-1 text-red-500 hover:text-red-700 hover:bg-red-100 rounded-full transition-colors")
            .attr("title", "Verwijder bestand")
            .html('<i class="fas fa-times"></i>')
            .on("click", function() {
                const fileIdToRemove = $(this).attr("data-file-id");
                const fileIndex = selectedFiles.findIndex(f =>
                    `${f.name}-${f.lastModified}` === fileIdToRemove
                );

                if (fileIndex !== -1) {
                    selectedFiles.splice(fileIndex, 1);
                    updateSelectedFilesList();
                }
            });

        $fileItem.append($deleteBtn);
        $fileList.append($fileItem);
    });

    $filesList.append($fileList);
}

$(".ORDERUPLOAD").on("submit", function (e) {
    e.preventDefault();

    if (selectedFiles.length === 0) {
        alert("Selecteer eerst bestanden om te uploaden.");
        return;
    }

    const id = $(this).data("id");
    const formData = new FormData();

    selectedFiles.forEach(file => {
        formData.append("uploadFile[]", file);
    });

    $.ajax({
        type: "post",
        url: "/mijn-account/order/" + id + "/fileupload",
        data: formData,
        processData: false,
        contentType: false,
        beforeSend: function (e) {
            $(".orderupload").removeClass("hidden");
        },
        success: function (data) {
            window.location = "/mijn-account/order/" + id;
        },
        error: function (jqXHR, textStatus, errorMessage) {
            let errorOccurredDuringUpload = 'An error occurred during upload';

            if (jqXHR.responseJSON) {
                let errorKeys = Object.keys(jqXHR.responseJSON);

                if (errorKeys.length < 1) {
                    errorOccurredDuringUpload = jqXHR.responseJSON;
                }

                const firstErrorKey = errorKeys[0];
                if (firstErrorKey && jqXHR.responseJSON[firstErrorKey]) {
                    errorOccurredDuringUpload = jqXHR.responseJSON[firstErrorKey];
                }
            }

            $(".orderupload").html(errorOccurredDuringUpload);
        }
    });
});

$(".acceptquote").on("submit", function (e) {
    $(".submitquote").prop("disabled", true);
});

$(".quoteform").on("submit", function (e) {
    $(".loader").show();
    $(".quotesubmit").attr("disabled", true);
});

$(".thumbsup").on("click", function (e) {
    e.preventDefault();

    $.ajax({
        type: "post",
        url: "/customerexperience",
        dataType: "json",
        data: {experience: 1},
        beforeSend: function () {
        },
        success: function (data) {
            $(".thumbsup").addClass("hidden");
            $(".thumbsdown").addClass("hidden");
            $(".response").removeClass("hidden");
        },
        error: function (xhr) {
            $(".product-title").append(xhr.responseJSON.errors);
            throw xhr.responseJSON.errors;
        }
    });
});

$(".thumbsdown").on("click", function (e) {
    e.preventDefault();

    $.ajax({
        type: "post",
        url: "/customerexperience",
        dataType: "json",
        data: {experience: 0},
        beforeSend: function () {
        },
        success: function (data) {
            $(".thumbsup").addClass("hidden");
            $(".thumbsdown").addClass("hidden");
            $(".response").removeClass("hidden");
        },
        error: function (xhr) {
            $(".product-title").append(xhr.responseJSON.errors);
            throw xhr.responseJSON.errors;
        }
    });
});

$(".SELECT_PRODUCT_INFORMATION").click(function () {
    const {value} = $(this).data();
    $(`.SELECT_PRODUCT_INFORMATION[data-value!="${value}"]`)
        .removeClass(["border-gray-700", "bg-gray-700", "text-white"])
        .addClass(["border-gray-300", "hover:bg-gray-700", "hover:text-white"]);

    $(`.SELECT_PRODUCT_INFORMATION[data-value="${value}"]`)
        .addClass(["border-gray-700 ", "bg-gray-700 ", "text-white"])
        .removeClass([
            "border-gray-300",
            "hover:bg-gray-700 ",
            "hover:text-white"
        ]);

    $(".PRODUCT_INFORMATION_PANE").addClass("hidden");
    $(`.PRODUCT_INFORMATION_PANE[data-value="${value}"]`).removeClass("hidden");
});

$(".ACTION_SCROLL_TO_WZD").click(function (e) {
    $('body, html').animate({scrollTop: $('#productoptions').offset().top - (heightHeader + 50)}, 500);
});

$(".ACTION_SCROLL_TO_THEMEPRODUCTS").click(function (e) {
    $('body, html').animate({scrollTop: $('.themeproducts').offset().top - (heightHeader + 50)}, 500);
});

$("#btn_subscribe_newsletter").click(function () {
    var email = $("#newsletter_email").val().trim();
    if (email === "") {
        $("#newsletter_email").removeClass("border-gray-300").addClass("border-red-700");
        return;
    } else {
        $("#newsletter_email").removeClass("border-red-700").addClass("border-gray-300");

        $.ajax({
            type: "post",
            url: "/subscribe-newsletter",
            dataType: "json",
            data: {email: email},
            success: function (data) {
                if (data.status === 200) {
                    $("#newsletter_email").val('');
                    $("#newsletter_response").removeClass("text-red-700").addClass("text-green-700").html(data.message);
                } else {
                    $("#newsletter_response").removeClass("text-green-700").addClass("text-red-700").html(data.message);
                }

            },
            error: function (xhr) {
                console.log('subscribe-newsletter error:', xhr.responseJSON.errors)
            }
        });
    }
});

$('button#addNewProduct').click(function () {
    const uploadFileId = $('.product-details-container').length;
    const firstDiv = $('.product-details-container').first();
    const content = firstDiv.clone();
    content.find('input[type=text]').val('');
    content.find('input[type=number]').val('');
    content.find("input[type=checkbox]").prop('checked', false).attr({name: 'finalfile[' + uploadFileId + ']'});
    content.find('input[type=file].upload-file').attr({id: 'uploadFile' + uploadFileId, name: 'uploadFile[' + uploadFileId + '][]'});
    content.find('.custom-file-upload').attr({for: 'uploadFile' + uploadFileId});
    content.find('.preview-files').empty();
    content.find('button.clear-file-selection').addClass('hidden');
    content.find('.upload-file-count').html('');

    content.find('.upload-another-file-section').addClass('hidden');
    content.find('input[type=file].upload-another-file').attr({id: 'uploadAnotherFile' + uploadFileId, name: 'uploadAnotherFile[' + uploadFileId + '][]'});
    content.find('.custom-another-file-upload').attr({for: 'uploadAnotherFile' + uploadFileId});
    content.find('.preview-another-files').empty();
    content.find('button.clear-another-file-selection').addClass('hidden');
    content.find('.upload-another-file-count').html('');

    $('.all-products-container').append(content);
});

$('.all-products-container').on('click', '.remove-product-details', function () {
    const parentDiv = $(this).closest('.product-details-container');
    parentDiv.remove();
});

$('.all-products-container').on('click', '.clear-file-selection', function () {
    const parentDiv = $(this).closest('.product-details-container');
    parentDiv.find('.upload-file').val('');
    parentDiv.find('.upload-file-count').html('');
    parentDiv.find('.preview-files').html('');
    $(this).addClass('hidden');
});

$('.all-products-container').on('change', '.upload-file', function (event) {
    var files = event.target.files;

    const parentDiv = $(this).closest('.product-details-container');
    var preview = parentDiv.find('.preview-files');
    preview.empty();

    if (files.length === 0) {
        return;
    }

    if (files.length > 0) {
        parentDiv.find('.upload-another-file-section').removeClass('hidden');

        parentDiv.find('.upload-file-count').html(files.length + ' Bestanden geselecteerd');
        parentDiv.find('button.clear-file-selection').removeClass('hidden');
    } else {
        parentDiv.find('.upload-file-count').html('');
    }

    $.each(files, function (index, file) {
        var reader = new FileReader();
        reader.onload = function (e) {
            const validImageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp'];
            if (validImageTypes.includes(file.type)) {
                preview.append("<div class='w-6/12 file-preview-container'>" +
                    "<div class='img-container'><img src='" + e.target.result + "' alt='' /></div>" +
                    "<p class='preview-file-name'>" + file.name + "</p>" +
                    "</div>");
            } else {
                preview.append("<div class='w-6/12 file-preview-container'>" +
                    "<div class='img-container'><img src='/images/document-placeholder-img.png' alt='' /></div>" +
                    "<p class='preview-file-name'>" + file.name + "</p>" +
                    "</div>");
            }
        };
        reader.readAsDataURL(file);
    });
});

/***/
$('.all-products-container').on('click', '.clear-another-file-selection', function () {
    const parentDiv = $(this).closest('.product-details-container');
    parentDiv.find('.upload-another-file').val('');
    parentDiv.find('.upload-another-file-count').html('');
    parentDiv.find('.preview-another-files').html('');
    $(this).addClass('hidden');
});

$('.all-products-container').on('change', '.upload-another-file', function (event) {
    var files = event.target.files;

    const parentDiv = $(this).closest('.product-details-container');
    var preview = parentDiv.find('.preview-another-files');
    preview.empty();

    if (files.length === 0) {
        return;
    }

    if (files.length > 0) {
        parentDiv.find('.upload-another-file-count').html(files.length + ' Bestanden geselecteerd');
        parentDiv.find('button.clear-another-file-selection').removeClass('hidden');
    } else {
        parentDiv.find('.upload-file-count').html('');
    }

    $.each(files, function (index, file) {
        var reader = new FileReader();
        reader.onload = function (e) {
            const validImageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp'];
            if (validImageTypes.includes(file.type)) {
                preview.append("<div class='w-6/12 file-preview-container'>" +
                    "<div class='img-container'><img src='" + e.target.result + "' alt='' /></div>" +
                    "<p class='preview-file-name'>" + file.name + "</p>" +
                    "</div>");
            } else {
                preview.append("<div class='w-6/12 file-preview-container'>" +
                    "<div class='img-container'><img src='/images/document-placeholder-img.png' alt='' /></div>" +
                    "<p class='preview-file-name'>" + file.name + "</p>" +
                    "</div>");
            }
        };
        reader.readAsDataURL(file);
    });
});
